import DpAssignmentCardI18n from './AssignmentCard/DpAssignmentCard.i18n.en';
import DpAttemptCardI18n from './AttemptCard/DpAttemptCard.i18n.en';
export default {
  components: {
    header: {
      navigationAriaLabel: 'Navigation Bar',
      skipToMain: 'Skip to main content',
      logoutModal: {
        title: 'Are you sure you want to log out?',
        content1: 'All unsaved changes will be lost',
        content2: 'Keep in mind:',
        content3: `If this account is connected through your school login, remember to log it out when you're done`,
        cancelButton: 'Cancel',
        logoutButton: 'Yes, log out'
      },
      logoutErrorMsg: "There was an internal error and we couldn't log you out."
    },
    tools: {
      title: 'You are being redirected',
      content: 'You are about to access an external website which is not maintained, managed, or owned by Great Minds PBC nor any affiliated entity. This link is being provided as a convenience and for informational purposes only; it does not constitute an endorsement or an approval by Great Minds PBC of any of the products, services, or opinions of the corporation or organization or individual accessible by this link. Great Minds PBC bears no responsibility for the accuracy, legality, security, or content (including whether it is age appropriate) of the external site or for that of subsequent links. Great Minds cannot guarantee the external sites or subsequent links meet Web Content Accessibility Guidelines (WCAG) or Section 508 accessibility criteria. By clicking "Agree" you expressly assume all risk associated with the foregoing. Contact the external site for answers to questions regarding its content.',
      agree: 'AGREE',
      cancel: 'CANCEL'
    },
    ...DpAssignmentCardI18n,
    ...DpAttemptCardI18n
  }
};